import * as API from "./apis";
import * as CONFIGURATION from "./configurations";
import * as ENUM from "./enums";
import * as ERROR_DICTIONARY from "./errorDictionaries";
import * as EVENT from "./eventKeys";
import * as FIELD_NAME from "./fieldNames";
import * as KEY from "./jsonKeys";
import * as MESSAGES from "./messages";
import * as SESSION_STORAGE_KEY from "./sessionStorageKeys";

export {
  MESSAGES,
  CONFIGURATION,
  API,
  KEY,
  FIELD_NAME,
  ENUM,
  EVENT,
  SESSION_STORAGE_KEY,
  ERROR_DICTIONARY,
};
export const { APP_ROOT } = CONFIGURATION;

export const { PRODUCT_NAME } = MESSAGES;

// TODO refactor changes the old device state should use the new device state definition
/**
 * @enum {String}
 */
export const DEVICE_STATE = {
  NONE: "NONE",
  IDLE: "IDLE",
  PREPARING: "PREPARING",
  PRIMING: "PRIMING",
  CONCENTRATING: "CONCENTRATING",
  DIAFILTRATION: "DIAFILTRATION",
  DIAFILTRATE: "DIAFILTRATE",
  RECOVERING: "RECOVERING",
  DEPRESSURIZING: "DEPRESSURIZING",
  STOPPING: "STOPPING",
  PAUSED: "PAUSED",
  REVERSE_DIAFILTRATION: "REVERSE DIAFILTRATION",
  FILL_MEMBRANE: "FILL_MEMBRANE",
  RUNNING: "RUNNING",
  BUFFER_RECOVERY: "BUFFER RECOVERY",
  REVERSE_DIAFILTRATE: "REVERSE DIAFILTRATE",
  PRIME: "PRIME",
  REVERSE_CONCENTRATE: "REVERSE CONCENTRATE",
  CONCENTRATE: "CONCENTRATE",
  MIXING: "MIXING",
};

/**
 * @deprecated
 */
export const PC_NONE_STATE = "NONE";
/**
 * @deprecated
 * @see {@link DEVICE_STATE}
 */
export const PC_IDLE_STATE = "IDLE";
/**
 * @deprecated
 * @see {@link DEVICE_STATE}
 */
export const PC_PREPARING_STATE = "PREPARING";
/**
 * @deprecated
 * @see {@link DEVICE_STATE}
 */
export const PC_PRIMING_STATE = "PRIMING";
/**
 * @deprecated
 * @see {@link DEVICE_STATE}
 */
export const PC_CONCENTRATING_STATE = "CONCENTRATING";
/**
 * @deprecated
 * @see {@link DEVICE_STATE}
 */
export const PC_DIAFILTRATING_STATE = "DIAFILTRATION";
/**
 * @deprecated
 * @see {@link DEVICE_STATE}
 */
export const PC_RECOVERING_STATE = "RECOVERING";
/**
 * @deprecated
 * @see {@link DEVICE_STATE}
 */
export const PC_DEPRESSURIZING_STATE = "DEPRESSURIZING";
/**
 * @deprecated
 * @see {@link DEVICE_STATE}
 */
export const PC_STOPPING_STATE = "STOPPING";
/**
 * @deprecated
 * @see {@link DEVICE_STATE}
 */
export const PC_PAUSED = "PAUSED";
/**
 * @deprecated
 * @see {@link DEVICE_STATE}
 */
export const PC_REVERSE_DIAFILTRATING_STATE = "REVERSE DIAFILTRATION";
/**
 * @deprecated
 * @see {@link DEVICE_STATE}
 */
export const PC_FILL_MEMBRANE = "FILL_MEMBRANE";

// css  style progress bar
export const CSS_NOT_STARTED = "notStarted";
export const CSS_ON_TRACK = "onTrack";
export const CSS_RISK = "risk";
export const CSS_LATE = "late";
export const CSS_COMPLATE = "complete";

// menu
export const SETUP = "SETUP";
export const STATUS = "STATUS";
export const ADVANCED_SETTINGS = "ADVANCED SETTING";
export const DEBUGGING = "DEBUGGING";
export const MORE_SETUP = "MORE OPTIONS";
export const EXPLORER = "EXPLORER";
export const SYSTEM_SETTING = "SYSTEM SETTINGS";
export const INFO_AND_SUPPORT = "INFO AND SUPPORT";
export const HOME = "HOME";
export const SEARCH_RESULT = "SEARCH RESULT";
export const CYCLE_HISTORY = "PROFILE HISTORY";
export const SYSTEM_LOGS = "SYSTEM LOGS";
export const SYSTEM_LOGS_SHORT = "LOGS";
export const SYSTEM_LOG = "SYSTEM LOG";
export const SELECT_FILE = "SELECT FILE";
export const SELECT_FOLDER = "SELECT FOLDER";
export const SELECT_FOLDER_SYSTEM_LOG = "SELECT FOLDER (SYSTEM LOG)";
export const CLEANING_WIZARD = "CLEANING WIZARD";
export const CALIBRATION_VOLUME_SENSOR = "CALIBRATION WIZARD";
export const RELEASE_NOTES = "RELEASE NOTES";
export const TIMEZONE = "TIME ZONE";

export const REMOTE_INFO_AND_SUPPORT = "Info and Support";

export const AUTO_PROFILE = "Auto Profile";
export const MANUAL_PROFILE = "Manual Profile";
export const DEBUG_PAGE = "Debug Page";

/**
 * @enum {String}
 */
export const PAGE_MENU = {
  MANUAL_PROFILE: "Manual Profile",
};

// popUp
export const YESORNO = "YESORNO";
export const UPDATE_SAVE_AS_DISCARD = "UPDATE_SAVE_AS_DISCARD";
export const OK = "OK";
export const TEXT_QUESTION_PROFILE =
  "Do you want to save the setting profile ?";
export const YES = "Yes";
export const NO = "No";
export const NO_I_DO_IT_LATER = "No, I'll do it later";
export const PAUSE = "Pause";
export const RESUME = "Resume";
export const APPLY = "Apply";
export const RESTORE = "Restore";
export const MINIMIZE = "Minimize";
export const CANCEL = "Cancel";
export const LATER = "Later";
export const SKIP = "Skip";
export const WAIT = "Wait";
export const BACK = "Back";
export const RESTART = "Restart";
export const RELOAD = "Reload";
export const CLOSE = "Close";
export const ACTIVATE = "ACTIVATE";
export const REMOTE_SUPPORT = "REMOTE SUPPORT";
export const UPDATE = "UPDATE";
export const SAVE_AS = "SAVE AS";
export const DISCARD = "Discard";
export const TRY_AGAIN = "Try Again";
export const IGNORE = "Ignore";
export const CONTINUE = "Continue";
export const SAVE = "SAVE";
export const FINISH = "FINISH";
export const LOAD_SETUP = "LOAD SETUP";
export const FIND_SETUP = "FIND SETUP";
export const SAVE_SETUP = "SAVE SETUP";
export const SAVE_SETUP_AS = "SAVE SETUP AS";
export const OPEN = "OPEN";
export const EXPORT = "EXPORT";
export const QUIT = "Quit";
export const EXIT = "Exit";
export const SAVE_CHANGES = "Save Changes";
export const SAVE_CHANGES_TEXT = "You've  made some changes to PROFILENAME.";
export const SAVE_CHANGES_QUESTION =
  "What do you want to do with this changes?";
export const DELETE_PROFILE = "Delete Profile";
export const DELETE_ADV_SETUP = "Delete Profile";
export const DELETE_HISTORY = "Delete History";
export const TITLE_INPUT_ERROR = "Input Error";
export const TITLE_SAVE_NEW_PROFILE = "Save Profile";
export const START = "Start";
export const NEXT = "NEXT";
export const RUN = "RUN";
export const RUN_NOW = "RUN NOW";
export const SCHEDULE_RUN = "SCHEDULE RUN";
export const EDIT_SCHEDULE = "EDIT SCHEDULE";
export const RESET = "Reset";
export const RESET_CALIBRATION = "Reset Calibration";
export const RESET_DEFAULT = "Reset Default";
export const USE_SELECTED_VALUE = "Use Selected Value";
export const CONFIRM = "CONFIRM";
export const EDIT = "EDIT";
export const DELETE = "DELETE";
export const STOP = "STOP";
export const STOP_AND_RECOVERY = "STOP AND RECOVERY";
export const PROCEED = "PROCEED";
export const TURN_ON = "Turn On";
export const TURN_OFF = "Turn Off";
export const CONNECT = "Connect";
export const DISCONNECT = "Disconnect";
export const PROCEED_TO_RECOVERY = "PROCEED TO RECOVERY";
export const RECOVER = "RECOVER";
export const FINISH_PROFILE = "FINISH PROFILE";
export const HELP = "HELP";
export const LOAD = "LOAD";
export const STOP_RINSE_CYCLE = "Stop Rinse Cycle";
export const REBOOT = "REBOOT";
export const SET_LATER = "LATER";
export const SET_UP_NOW = "SET UP NOW";
export const REFILL_BUFFER = "REFILL BUFFER";
export const CONTINUE_PROFILE = "CONTINUE PROFILE";
export const REMOVE = "REMOVE";
export const GOT_IT = "GOT IT";

// buttons
export const BTN_EXIT = "EXIT";
export const BTN_RINSE = "RINSE";
export const BTN_REPEAT = "REPEAT";

// hardware checkup
export const HARDWARE_CHECK_UP = "Hardware Check Up";
export const INITIAL_CHECK_UP = "Initial Check Up";
export const WELCOME_MESSAGE =
  "Welcome to Protein Concentrator!\n\nTo make sure you get the best experience with this product,\n we recommend you to run Hardware Check Up.\n\nDo you want to do it right now?";
export const BEFORE_RUN_MESSAGE =
  "Before running any cycle, please makes sure to check if all the hardware ready.\n\nDo you want to do hardware check up right now?";
export const HARDWARE_DETAIL_INFO_ERROR = "Info";

export const HARDWARE_CHECK_UP_IDLE_STATE = "Idle";
export const HARDWARE_CHECK_UP_RUNNING_STATE = "Running";
export const HARDWARE_CHECK_UP_PAUSED_STATE = "Paused";
export const HARDWARE_CHECK_UP_FINISHED_STATE = "Finished";

export const READY = "Ready";
export const CHECKING = "Checking";
export const ERROR = "Error";
export const UNKNOWN = "Unknown";

// warning
export const ADVANCED_SETTINGS_WARNING =
  "Please be aware that changing settings in this page could be harmful to stability and performance";

export const SETUP_ADDRESS = "#/setup";
export const SETUP_EXT_ADDRESSS = "#/setupext";
export const STATUS_ADDRESS = "#/status";
export const ADVANCE_SETTING_ADDRESS = "/#/advancedsettings";
export const EXPLORER_ADDRESS = "#/explorer";
export const INFO_AND_SUPPORT_ADDRESS = "#/info";
export const HOME_SCREEN_ADDRESS = "#/";
export const DEVICE_SETTING_ADDRESS = "#/devicesetting";
export const TIMEZONE_SETTING_ADDRESS = "#/timezonesetting";
export const DISPLAY_SETTING_ADDRESS = "#/displaysetting";
export const GENERAL_SETTING_ADDRESS = "#/generalsetting";
export const PRESSURE_SETTING_ADDRESS = "#/pressuresetting";
export const VOLUME_THRESHOLD_ADDRESS = "#/volumethresholdsetting";
export const WIFI_SETTING_ADDRESS = "#/wifisetting";
export const WIFI_SETTING_ADDRESS_WITHOUT_HASH = "wifisetting";
export const CYCLE_HISTORY_ADDRESS = "#/cyclehistory";
export const SYSTEM_LOGS_ADDRESS = "#/systemlogsmenu";
export const USB_FILE_LIST_ADDRESS = "#/usbfilelist";
export const USB_FOLDER_LIST_ADDRESS = "#/usbfolderlist";
export const USB_FOLDER_LIST_ADDRESS_SYSTEM_LOG = "#/usbfolderlistsystemlog";
export const CLEANING_WIZARD_ADDRESS = "#/cleaningwizard";
export const RINSE_WIZARD_ADDRESS = "#/rinsewizard";
export const COMPLETE_RINSE_WIZARD_ADDRESS = "#/completerinsewizard";
export const CALIBRATION_VOLUME_SENSOR_WIZARD_ADDRESS =
  "#/calibration-volume-sensor";
export const CALIBRATION_LOAD_CELL_SENSOR_ADDRESS =
  "#/calibration-load-cell-sensor";
export const CALIBRATION_LOAD_CELL_SENSOR_CHECK_SCALE_ADDRESS =
  "#/calibration-load-cell-sensor-check-scale";
export const CALIBRATION_LOAD_CELL_SENSOR_CALIBRATE_SCALE_ADDRESS =
  "#/calibration-load-cell-sensor-calibrate-scale";
export const WARMING_UP_ADRESS = "#/warmingup";
export const CALIBRRATION_HISTORY_ADRESS = "#/calibrationhistory";
export const RELEASE_NOTES_ADDRESS = "#/releasenotes";
export const MANUAL_PROFILE_ADDRESS = "#/manualprofile";
export const MANUAL_PROFILE_EXPLORER_ADDRESS = "#/manualprofileexplorer";
export const VOLUME_SENSOR_CHART_ADDRESS = "#/volumesensorchart";
export const ADVANCE_SETUP_GENERAL_SETUP = "#/generalsetup";
export const ADVANCE_SETUP_CONCENTRATE_SETUP = "#/concentratesetup";
export const ADVANCE_SETUP_PRIME_SETUP = "#/primesetup";
export const ADVANCE_SETUP_DIAFILTRATION_SETUP = "#/diafiltrationsetup";
export const ADVANCE_SETUP_RECOVERY_SETUP = "#/recoverysetup";
export const ADVANCE_SETUP_EXPLORER = "#/advsetupexplorer";
export const ADVANCE_SETUP_ADDRESS = "#/advsetup";
export const AUTO_PROFILE_SETUP = "#/autoprofilesetup";
export const AUTO_PROFILE_STATUS = "#/autoprofilestatus";
export const AUTO_PROFILE_PARAMETERS = "#/autoprofileparameters";
export const ERROR_PAGE_ADDRESS = "#/error";
export const SHUTDOWN_PAGE_ADDRESS = "#/shutdownpage";
export const REMOTE_SUPPORT_PAGE_ADDRESS = "#/remotesupport";
export const ADVANCE_SETUP_CYCLE_SETUP = "#/cyclesetup";
export const ALL_HARDWARE_VALUE_ADDRESS = "#/allhardwarevalue";

export const MAX_PROFILE_VIEW = 12;
export const MAX_ADV_SETUP_VIEW = 12;

export const INFO_PAGE = {
  DEVICE_SERIAL_NUMBER: "Device Serial Number",
  FIRMWARE_NAME: "Firmware Name",
  FIRMWARE_VERSION: "Firmware Version",
  SOFTWARE_NAME: "Software Name",
  SOFTWARE_VERSION: "Software Version",
  BUILD_DATE: "Build Date",
  HOST_NAME: "Host Name",
  IP_ADDRESS: "IP Address",
  MAC_ADDRESS: "MAC Address",
  RELEASE_DATE: "Release Date",

  LICENSE_STATUS: "License Status",
  LICENSE_TYPE: "License Type",
  LICENSE_MODIFIED_DATE: "License Modified Date",
  LICENSE_EXPIRED_DATE: "Eligible for Updates Through",
  CLIENT_ID: "Client ID",
};

export const LICENSE_ACTIVATION_MODE = {
  ONLINE: "ONLINE",
  OFFLINE: "OFFLINE",
  TRIAL: "TRIAL",
};

export const USB_OPEN_FOR = {
  IMPORT_UPDATE: "IMPORT_UPDATE",
  IMPORT_LICENSE: "IMPORT_LICENSE",
  EXPORT_CYCLE_HYSTORY: "EXPORT_CYCLE_HYSTORY",
  EXPORT_SYSTEM_LOGS: "EXPORT_SYSTEM_LOGS",
};
// export const DEBUGGING_ADDRESS = "Debugging Address";
export const FMLX_CONTACT = `Ph: +1 781-788-0228 \n Fax: +1 781-207-5522 \n Email: ${MESSAGES.EMAIL_SUPPORT} \n 10 DeAngelo Drive, Bedford, MA 01730 \n https://formulatrix.com`;
export const UPDATE_SOFTWARE = "Update Software";
export const UPDATE_SOFTWARE_NO_INTERNET =
  "Oops! Your device doesn’t connect to internet. \nPlease make sure you have internet connection and try again";
export const ONLINE_UPDATE = "Online Update";
export const REMOTE_SUPPORT_TEXT =
  "Contact us and press this button if you need remote support";

export const SHUT_DOWN = "SHUT_DOWN";
export const WIFI_AVAILABLE = "WIFI_AVAILABLE";
export const WIFI_UNAVAILABLE = "WIFI_UNAVAILABLE";

export const DownloadState = {
  IDLE: "IDLE",
  DOWNLOADING: "DOWNLOADING",
  COMPLETE: "COMPLETE",
  FAILED: "FAILED",
  TIMEOUT: "TIMEOUT",
  CANCELED: "CANCELED",
};

export const AUTO_PROFILE_STATE = {
  CONCENTRATION: FIELD_NAME.CONCENTRATE,
  CONC_TWO_TUBES: FIELD_NAME.CONC_TWO_TUBES,
  CONCENTRATION_MORE_50: FIELD_NAME.CONCENTRATION_MORE_50,
  BUFFER_EXCHANGE: FIELD_NAME.BUFFER_EXCHANGE,
};

export const ADVANCE_SETUP_TITLE = {
  GENERAL: "GENERAL SETUP",
  CONCENTRATE: "CONCENTRATE CYCLE",
  DIAFILTRATION: "BUFFER EXCHANGE CYCLE",
  PRIME: "PRIME CYCLE SETUP",
  RECOVERY: "RECOVERY CYCLE SETUP",
};
/**
 * @enum {String}
 */
export const WIFI_STATUS = {
  ON: "ON",
  OFF: "OFF",
  CONNECTED: "CONNECTED",
};

/**
 * @enum {String}
 */
export const POWER = {
  ON: "ON",
  OFF: "OFF",
};

export const DELETE_RECENT_PROFILE_MESSAGE =
  "Can't delete PROFILENAME\nThis profile is in use";
export const DELETE_RECENT_ADV_SETUP_MESSAGE =
  "Can't delete ADVSETUPNAME\nThis advanced setup is in use";
export const SETTING_PROFILE_SAVED = "Setting Profile Saved";
export const DELETE_PROFILE_QUESTION =
  "Are you sure you want to delete PROFILENAME\npermanently?";

// top menu
export const LOCK_ACCESS = "Set PIN to Lock";
export const UNLOCK_ACCESS = "Set PIN to Unlock";
export const PROFILE_NAME = "Profile Name";

// DEVICE SETTING
export const PUMP_THRESHOLD = "PUMP THRESHOLD";
export const CYCLE_THRESHOLD = "CYCLE THRESHOLD";
export const DEVICE_SETTING = "DEVICE SETTINGS";
export const DISPLAY_SETTING = "DISPLAY SETTINGS";
export const GENERAL_SETTING = "GENERAL SETTINGS";
export const PRESSURE_SETTING = "PRESSURE SETTINGS";
export const VOLUME_THRESHOLD_SETTING = "THRESHOLD SETTINGS";
export const WIFI_SETTING = "WIFI SETTINGS";
export const CALIBRATION_LOAD_CELL_SENSOR = "CALIBRATION WIZARD";
export const DEVICE_SETTING_TAB = "SYSTEM SETTINGS - DEVICE SETTINGS";
export const DISPLAY_SETTING_TAB = "SYSTEM SETTINGS - DISPLAY SETTINGS";
export const CALIBRATION_LOAD_CELL_SENSOR_TAB = "SYSTEM SETTINGS - CALIBRATION";
export const WIFI_SETTING_TAB = "SYSTEM SETTINGS - WIFI SETTINGS";
export const CALIBRATION_LOAD_CELL_CHECK_SCALE = "CHECK SCALES";
export const CALIBRATION_LOAD_CELL_CALIBRATE_SCALE = "CALIBRATE SCALES";
export const CALIBRATION_HISTORY = "HISTORY";
export const DEVICE_ID = "Device Id";
export const DEVICE_NAME = "Device Name";
export const ORGANIZATION = "Organization";
export const DEVICE_DATE_TIME = "Device Date and Time";
export const DEVICE_DATE = "Date";
export const DEVICE_TIME = "Time";
export const DEVICE_TIME_ZONE = "Time Zone";
export const SET_AUTO_TIME_ZONE = "Set timezone, date & time automatically";
export const SET_AUTO_DATE_TIME = "Set date & time automatically";
export const ERROR_PAGE = "ERROR PAGE";
export const DATA_COLLECTION_USERNAME = "Username";
export const DATA_COLLECTION_PASSWORD = "Password";
export const DATA_COLLECTION_USERNAME_PLACEHOLDER = "Enter your username";
export const DATA_COLLECTION_PASSWORD_PLACEHOLDER = "Enter your Password";
export const DATA_COLLECTION_PASSWORD_CONFIRMATION_PLACEHOLDER =
  "Confirm your Password";

export const PRESSURE_SOURCE = "Pressure Source";
export const VACUUM_SOURCE = "Vacuum Source";
export const TUBE_PRESSURE = "Tube Pressure";
export const SOURCE_ON = "Source On";
export const SOURCE_OFF = "Source Off";
export const DRAIN_ON = "Drain On";
export const DRAIN_OFF = "Drain Off";
export const PRESSURE_SENSOR_SCALE = "Pressure Sensor Scale";
export const PRESSURE_SENSOR_OFFSET = "Pressure Sensor Offset";

// cycleThreshold
export const PRIMING_THRESHOLD = "Priming Threshold";
export const CONCENTRATING_THRESHOLD = "Concentration Threshold";
export const DIAFILTRATING_THRESHOLD = "Diafiltrating Threshold";
export const TARGET_PRESSURE_TIME_LIMIT = "Target Pressure Time Limit";
export const VOLUME_SENSING_CALIBRATION = "Volume Sensing Time limit";
export const TIME = "Time";
export const ELAPSED_TIME = "Elapsed Time";
export const ELAPSED_TIME_IN_SECONDS = "Elapsed Time (in seconds)";
export const CYCLE = "Cycle";
export const STATE = "State";
export const VOLUME_DIFFERENCE = "Volume Difference";

// advaced setup
export const ADVANCED_SETUP_NEW = "ADV. SETUP";
export const ADVANCED_SETUP_EXPLORER = "ADVANCED SETUP EXPLORER";
export const ADV_SETUP_NAME = "Adv Setup Name";

export const NO_PROFILE = "No Profile";
export const EMPTY_FIELD = ""; // (Number.MAX_VALUE).toString()
export const EMPTY_FIELD_NUMERIC = 9999999; // (Number.MAX_VALUE).toString()

export const SMALL_FONT_SIZE = 20;
export const MEDIUM_FONT_SIZE = 22;
export const LARGE_FONT_SIZE = 24;

export const SMALL = "SMALL";
export const MEDIUM = "MEDIUM";
export const LARGE = "LARGE";

export const FONT_SIZE = "Font Size";
// explorer
export const SEARCH_PROFILE_NAME = "Search Profile Name";
export const SEARCH_ADV_SETUP_NAME = "Search Advanced Setup Name";

export const MAX_TUBE_VOLUME = 50;
export const MIN_TUBE_VOLUME = 0;

export const NUMPAD_MODE_NORMAL = "normal";
export const NUMPAD_MODE_PASSWORD = "password";
export const PASSWORD = "Password";
export const FORGET_BUTTON = "ForgetButton";
export const CONNECT_BUTTON = "ConnectButton";
export const CONNECT_LOADING = "Connecting...";
export const DISCONNECT_LOADING = "Disconnecting...";
export const SSID = "SSID";
export const SECURITY = "Security";
export const CONNECT_ADD_NETWORK = "ConectAddNetwork";

export const SECURITY_TYPE = {
  NONE: "NONE",
  WEP: "WEP",
  WPA2: "WPA 2",
  WPA3: "WPA 3",
};

export const UNIT = {
  ml: "mL",
  mg_per_ml: "mg/mL",
  psi: "psi",
  ms: "ms",
  minutes: "minutes",
  mL_per_min: "mL/min",
  steps: "steps",
  times: "times",
  s: "s",
  kda: "kDa",
  percentage: "%",
};

export const SUCCESS_UPDATE_AND_WAIT_FOR_RESTART =
  "System will update and restart immediately";

export const BUFFER_THRESHOLD = 3;
export const DIAFILTRATION_USE = 2; // ml

// AUTO PROFILE
export const AUTO_PROFILE_SETUP_TAB = "AUTO PROFILE - SETUP";
export const AUTO_PROFILE_STATUS_TAB = "AUTO PROFILE - STATUS";
export const AUTO_PROFILE_PARAMETERS_TAB = "AUTO PROFILE - PARAMETERS";
export const VOLUME_SENSOR_CHART = "AUTO PROFILE - GRAPH";

export const AUTO_PROFILE_MENU = {
  SETUP: "SETUP",
  STATUS: "STATUS",
  GRAPH: "GRAPH",
  PARAMETERS: "PARAMETERS",
};
export const VOLUME_SENSOR_TYPE = {
  LOAD_CELL: "LOADCELL",
  CAPACITANCE: "CAPACITANCE",
};
// AUTO PROFILE HELP
export const HOME_HELP = "homeHelp";
export const CONCENTRATE_HELP = "Concentrate";
export const CONCENTRATE50ML_HELP = "Concentrate50ml";
export const BUFFER_DISCRETE_HELP = "BufferDiscrete";
export const BUFFER_CONTINOUS_HELP = "BufferContinous";
export const ADVANCED_SETUP_HELP = "AdvancedSetup";
export const STATUS_GRAPH_HELP = "StatusAndGraph";
export const MANUAL_CONTROL_HELP = "ManualControl";
export const RECOVERY_HELP = "Recovery";
export const LEARN_MORE_HELP = "LearnMoreHelp";
export const BACK_TO_TOP = "BACK";

// Manual Profile
export const MANUAL_PROFILE_EXPLORER = "MANUAL PROFILE EXPLORER";
export const SEQUENCE = "sequence";

// Cycle History

export const VIEW_CYCLE_HISTORY = "VIEW PROFILE HISTORY";
export const SAVE_MANUAL_PROFILE = "Save Manual Profile";
export const SAVE_MANUAL_PROFILE_AS = "Save Manual Profile As";
export const SAVE_MANUAL_PROFILE_PLACEHOLDER = "Manual Profile Setup Name";
export const SAVE_AS_MANUAL_PROFILE_QUESTION =
  "Do you want to save the changes you made to '<manualProfile name>'?";
export const SAVE_MANUAL_PROFILE_QUESTION =
  "Do you want to save the Manual Profile?";

export const INACTIVE_LICENSE = "INACTIVE LICENSE";
